import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-5 bg-sunset-bg">
      <p className="kicker text-sunset-accent mb-4">Error 404</p>
      <h1 className="font-serif text-6xl md:text-8xl tracking-tight mb-6">Página no encontrada</h1>
      <p className="text-sunset-muted max-w-md mb-8">La página que buscas no existe o fue movida.</p>
      <Link to="/" className="bg-sunset-ink text-white kicker px-9 py-4 hover:bg-sunset-accent transition-colors">Volver al inicio</Link>
    </div>
  );
}
